/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { extend } from '../extend/index.js';
import uploadFile$1 from './dingTalk/index.js';
import uploadFile$2 from './panguMiniApp/index.js';
import '../../tslib.es6-e01eabb2.js';
import '../env/index.js';
import '../../index-f24a9ec1.js';
import '../../index-892d8eee.js';
import '../extend/register/index.js';
import '../../bridges/dd/index.js';
import '../../index-6f6b9acc.js';
import '../../_commonjsHelpers-56d33373.js';
import '../../loadscripts-cf212b8d.js';
import '../../constants-163bd007.js';
import '../../bridge-adpter-api-0316c034.js';
import '../../bridges/windvane/index.js';
import '../../bridges/nebula/index.js';
import '../../index.es-142c5680.js';
import '../../bridges/pangu-mini-app/index.js';
import '../../log-aabf3a34.js';

/**
 * 上传图片
 * 支持端：菜鸟钉h5(图片) 钉钉小程序(图片、视频、音频)
 * @returns {Promise<unknown>} promise调用结果
 * @example 使用案例：
 * import { uploadFile } from '@alife/cn-uni-api'; //
 *
 * uploadFile({
 *    url: '链接'
 *    fileName: '文件名',
 *    filePath: '文件路径',
 *    fileType: '文件类型'
 * })
 *   .then((res) => {
 *     console.log('success', res);
 *   })
 *   .catch((error) => {
 *     console.log('fail', error);
 *   });
 * @author 余国平
 */
var uploadFile = extend({
    web: {
        dingTalk: uploadFile$1,
    },
    panguMiniApp: uploadFile$2,
});

export { uploadFile };
